import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const dataSlice = createSlice({
  name: 'data',
  initialState: {
    data: [],
    headers: [],
    headerIndexes: {},
    loading: false,
    error: null,
  },
  reducers: {
    fetchDataStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchDataSuccess(state, action) {
      state.loading = false;
      state.data = action.payload.data;
      state.headers = action.payload.headers;

      const headerIndexes = {};
      state.headers.forEach((header, index) => {
        headerIndexes[header.trim()] = index;
      });
      state.headerIndexes = headerIndexes;

      // Find the index of "Start Date" and convert its values to DD/MM/YYYY
      const startDateIndex = state.headerIndexes['Start Date'];

      if (startDateIndex !== undefined) {
        state.data = state.data.map(row => {
          const startDate = new Date(row[startDateIndex]);
          const formattedDate = startDate
            .toLocaleDateString('en-GB') // en-GB uses DD/MM/YYYY format
            .split('/')
            .reverse()
            .join('/'); // Ensure the format is DD/MM/YYYY
          
          // Replace the original date with the formatted one
          row[startDateIndex] = formattedDate;
          return row;
        });
      }
    },
    fetchDataFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Actions
export const { fetchDataStart, fetchDataSuccess, fetchDataFailure } = dataSlice.actions;

// Async Thunk to Fetch Data using axios
export const fetchData = () => async (dispatch) => {
  dispatch(fetchDataStart());

  try {
    console.log("Fetching data...");

    const response = await axios.get(
      'https://script.google.com/macros/s/AKfycbxXqpzSSVm9Y8NHVdSl_kT-GJSP9sbgU7ys8A1zEqGcnpA_IRrSnqDJmXhmiFx5Mvsc/exec'
    );

    console.log("Response received:", response);

    const data = response.data; // Directly access the parsed data
    console.log("Fetched Data:", data);

    if (!data || data.length === 0) {
      throw new Error("Empty response from API");
    }

    const headers = data[0]; // First row as headers
    const tasks = data.slice(1); // All tasks are in the rows after the header row

    console.log("Parsed Headers:", headers);
    console.log("Parsed Tasks:", tasks);

    // Dispatch success with structured data
    dispatch(fetchDataSuccess({ data: tasks, headers }));
  } catch (err) {
    console.error("API Fetch Error:", err);
    dispatch(fetchDataFailure(err.message));
  }
};

// Reducer
export default dataSlice.reducer;
